export default __webpack_public_path__ + "static/media/screen2.686bd20f.png";